var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _g4, _path19, _path20, _path21, _path22, _g5, _path23, _path24, _path25, _path26, _g6, _path27, _path28, _path29, _path30, _g7, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfinandinhoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 198,
    viewBox: "0 0 303 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 105.5,
    r: 80.5,
    fill: "#D7D7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.787 144.546C218.458 149.251 239.839 135.498 244.544 113.828C249.25 92.1576 235.496 70.776 213.826 66.0709C192.156 61.3658 170.774 75.1189 166.069 96.7893C161.364 118.46 175.117 139.841 196.787 144.546Z",
    fill: "#77B255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.402 118.187C197.885 118.078 197.394 117.868 196.959 117.569C196.523 117.269 196.151 116.887 195.863 116.444L186.648 102.117C186.361 101.672 186.165 101.174 186.071 100.653C185.977 100.132 185.986 99.598 186.098 99.0806C186.325 98.0357 186.958 97.1237 187.857 96.5452C188.757 95.9668 189.849 95.7693 190.894 95.9962C191.939 96.223 192.851 96.8557 193.429 97.755L200.455 108.731L220.951 95.5132C221.851 94.9347 222.943 94.7372 223.988 94.9641C225.033 95.191 225.945 95.8236 226.523 96.7229C227.101 97.6222 227.299 98.7144 227.072 99.7593C226.845 100.804 226.213 101.716 225.313 102.295L201.435 117.654C200.989 117.938 200.492 118.131 199.971 118.223C199.451 118.314 198.918 118.302 198.402 118.187Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 61,
    width: 119,
    height: 101
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7837 69.5749L158.969 61.8887L165.31 153.616L54.1248 161.302L47.7837 69.5749Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9768 57.7212L154.34 22.5584L184.7 137.74L51.3371 172.903L20.9768 57.7212Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9773 57.7177L154.341 22.5549L184.701 137.736L51.3375 172.899L20.9773 57.7177Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9778 57.7142L154.341 22.5514L184.701 137.733L51.338 172.896L20.9778 57.7142Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 66,
    width: 109,
    height: 93
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6356 127.002C66.0015 167.215 107.41 157.992 116.752 155.35C118.014 154.99 119.266 154.63 120.529 154.281C129.871 151.639 169.969 137.826 158.603 97.6129C147.096 56.9294 104.852 66.8538 96.1775 69.3626C95.1292 69.6642 94.0693 69.9557 93.0202 70.2464C84.3174 72.659 43.128 86.318 54.6356 127.002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8415_3186)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6578 69.2202L54.6878 190.723L190.451 154.925L158.422 33.4332L22.6578 69.2202Z",
    fill: "url(#paint0_linear_8415_3186)"
  })))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 67,
    width: 106,
    height: 83
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7256 74.7523L153.792 67.8347L158.98 142.884L58.9137 149.802L53.7256 74.7523Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9788 57.7204L154.342 22.5576L184.702 137.739L51.339 172.902L20.9788 57.7204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9798 57.7169L154.343 22.5541L184.703 137.736L51.34 172.898L20.9798 57.7169Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9807 57.7135L154.344 22.5506L184.704 137.732L51.341 172.895L20.9807 57.7135Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 71,
    width: 99,
    height: 77
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.637 101.766C156.861 109.631 157.293 116.824 155.93 123.311C151.046 118.15 144.844 114.76 137.359 113.172C125.456 110.646 113.782 113.308 109.32 114.576L109.02 114.662C108.486 114.819 107.961 114.965 107.416 115.122C106.88 115.268 106.346 115.425 105.81 115.571L105.51 115.647C101.048 116.904 89.7049 120.743 80.8914 129.131C75.3427 134.402 71.8283 140.537 70.3779 147.488C65.8231 142.675 62.4055 136.322 60.1925 128.456C55.5865 112.17 58.6833 98.7334 69.4123 88.5439C78.2374 80.166 89.5692 76.3279 94.0425 75.0696L94.3312 74.9841C94.8658 74.8272 95.4012 74.6811 95.9366 74.535C96.4712 74.378 97.0059 74.221 97.5412 74.0749L97.8408 73.9887C102.302 72.7202 113.977 70.0585 125.88 72.585C140.351 75.6539 150.031 85.48 154.637 101.766Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4999 77.8272L62.925 166.705L172.524 137.81L149.099 48.933L39.4999 77.8272Z",
    fill: "url(#paint1_linear_8415_3186)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 79,
    width: 100,
    height: 68
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2764 85.6769L151.784 79.1437L156.011 140.295L61.5038 146.829L57.2764 85.6769Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9773 57.7214L154.341 22.5585L184.701 137.74L51.3375 172.903L20.9773 57.7214Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9778 57.7179L154.341 22.5551L184.701 137.736L51.338 172.899L20.9778 57.7179Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9783 57.7144L154.342 22.5516L184.702 137.733L51.3385 172.896L20.9783 57.7144Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.672 130.815L91.7881 143.209C78.926 146.848 65.5721 139.425 61.9483 126.616C58.3252 113.819 65.8155 100.493 78.6891 96.8644L122.562 84.46C135.424 80.8216 148.789 88.2545 152.402 101.053C156.025 113.851 148.534 127.176 135.672 130.815Z",
    fill: "#CCCCCC"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 120,
    width: 16,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.438 121.522L118.336 120.561L119.105 131.68L105.207 132.64L104.438 121.522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9758 57.7284L154.339 22.5656L184.699 137.747L51.3361 172.91L20.9758 57.7284Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9763 57.7257L154.34 22.5628L184.7 137.744L51.3366 172.907L20.9763 57.7257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9768 57.7229L154.34 22.5601L184.7 137.741L51.3371 172.904L20.9768 57.7229Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.467 124.695C106.467 124.695 111.721 125.259 116.262 121.825C116.252 121.837 116.803 123.49 116.833 123.608C117.113 124.821 117.256 126.099 117.113 127.341C116.846 129.476 115.192 131.904 112.78 131.896C111.907 131.891 111.031 131.526 110.321 131.04C108.214 129.604 107.14 127.016 106.467 124.695Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 105,
    width: 15,
    height: 8
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.156 106.464L134.054 105.503L134.439 111.063L120.541 112.023L120.156 106.464Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9812 57.7207L154.345 22.5579L184.705 137.739L51.3415 172.902L20.9812 57.7207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9827 57.7172L154.346 22.5544L184.706 137.736L51.3429 172.899L20.9827 57.7172Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9841 57.7138L154.347 22.5509L184.708 137.732L51.3444 172.895L20.9841 57.7138Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.075 106.064C128.627 105.793 130.187 105.794 131.71 106.049C132.748 106.228 133.439 107.217 133.259 108.244C133.079 109.282 132.08 109.973 131.053 109.793C128.867 109.42 126.516 109.823 124.585 110.916C123.661 111.438 122.504 111.115 121.982 110.202C121.461 109.289 121.785 108.132 122.709 107.609C124.053 106.851 125.523 106.335 127.075 106.064Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 113,
    width: 16,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6279 114.715L95.526 113.754L96.2947 124.873L82.3965 125.834L81.6279 114.715Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9802 57.7232L154.344 22.5604L184.704 137.742L51.3405 172.905L20.9802 57.7232Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9812 57.726L154.345 22.5632L184.705 137.745L51.3415 172.907L20.9812 57.726Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9822 57.7288L154.346 22.566L184.706 137.747L51.3424 172.91L20.9822 57.7288Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3507 117.375C89.8175 116.815 91.3451 116.502 92.8914 116.461C93.9476 116.432 94.8235 117.266 94.8522 118.311C94.8699 119.357 94.0359 120.233 92.9905 120.262C90.7687 120.317 88.5482 121.18 86.8591 122.627C86.0658 123.304 84.8602 123.224 84.1727 122.431C83.4742 121.639 83.5662 120.444 84.3695 119.756C85.5435 118.747 86.8846 117.945 88.3507 117.375Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 22,
    width: 150,
    height: 113
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6382 32.0085L167.399 22.2086L174.509 125.055L32.7479 134.854L25.6382 32.0085Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9773 57.7265L154.341 22.5637L184.701 137.745L51.3375 172.908L20.9773 57.7265Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9778 57.7238L154.341 22.561L184.701 137.742L51.338 172.905L20.9778 57.7238Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_8415_3186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_8415_3186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 165,
    height: 151
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9783 57.721L154.342 22.5582L184.702 137.74L51.3385 172.902L20.9783 57.721Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_8415_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.141 69.327L143.65 39.2902C146.514 37.4776 147.792 33.7126 146.132 30.369C144.89 27.8692 142.166 26.3447 139.369 26.6035C134.925 27.0198 132.133 31.2931 133.276 35.3598C134.127 38.3557 136.859 40.327 139.841 40.3718L148.275 70.2052C141.708 65.0188 134.586 62.3582 128.364 61.0428C113.881 57.9638 99.9389 61.1313 94.6205 62.6336L94.2458 62.7359C93.7437 62.8906 93.23 63.0352 92.7373 63.1675C92.2128 63.3128 91.71 63.4567 91.1746 63.6028L90.8215 63.7035C85.5032 65.2058 71.9659 69.8073 61.2267 80.0085C56.6914 84.315 52.1006 90.1855 49.2147 97.8363L40.8702 68.3458C43.7334 66.5223 45.0114 62.7574 43.3619 59.413C42.12 56.9133 39.3861 55.4003 36.6001 55.6584C32.1451 56.0754 29.3522 60.3379 30.5069 64.4147C31.3576 67.4106 34.0796 69.3826 37.0603 69.4165L45.5517 99.4533C38.4572 101.46 34.3174 108.805 36.3112 115.868L38.7227 124.396C39.4705 127.006 41.2066 129.079 43.4083 130.313C45.0076 131.195 46.8382 131.636 48.708 131.539C49.4478 131.51 50.1925 131.393 50.9196 131.179L52.5887 130.703L52.5609 130.618C45.7588 106.552 55.0081 91.37 63.9552 82.8637C74.0486 73.2636 86.8517 68.931 91.8806 67.5033L92.2228 67.4033C93.2618 67.1242 94.321 66.8219 95.3266 66.5341L95.6905 66.4326C100.719 65.0049 113.91 62.0093 127.528 64.8972C139.608 67.4659 155.442 75.5683 162.244 99.6233L162.261 99.7203L164.165 99.1741C164.83 98.9973 165.445 98.7474 166.024 98.4455C167.783 97.5384 169.182 96.1544 170.115 94.4971C171.349 92.2953 171.753 89.6271 171.005 87.006L168.594 78.4885C166.61 71.4142 159.236 67.3201 152.141 69.327ZM34.316 63.3331C33.8799 61.7595 34.7925 60.1254 36.3769 59.6886C37.9498 59.2417 39.5838 60.1542 40.03 61.7162C40.477 63.2891 39.5535 64.9239 37.9807 65.3708C36.3963 65.8077 34.7622 64.8951 34.316 63.3331ZM137.086 34.2891C136.65 32.7155 137.573 31.0807 139.147 30.6446C140.72 30.1977 142.364 31.1095 142.8 32.6722C143.247 34.245 142.323 35.8799 140.75 36.3268C139.177 36.7629 137.532 35.8511 137.086 34.2891Z",
    fill: "#662D91"
  }))))))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.408 50.0642C223.007 49.2354 222.266 48.6345 221.208 47.3738C220.583 47.8816 220.139 48.4252 219.943 49.1503C220.57 50.065 221.578 51.0008 223.044 52.1242C223.248 50.958 223.541 50.3963 224.408 50.0642Z",
    fill: "#61BA47"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.431 86.4976C260.511 85.2797 261.242 84.666 262.68 83.8676C262.301 83.1574 261.852 82.6175 261.177 82.2878C260.16 82.7294 259.049 83.5406 257.668 84.7664C258.774 85.1888 259.27 85.5828 259.431 86.4976Z",
    fill: "#007AFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.047 88.0298C234.604 86.992 234.454 86.1477 234.186 84.8847C233.094 84.2772 232.333 83.7001 231.359 83.329C230.445 84.3109 229.619 84.7621 227.939 84.9292C230.112 86.6146 231.559 87.2403 234.047 88.0298Z",
    fill: "#61BA47"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.467 39.9372C180.876 39.5909 179.983 39.2536 178.583 38.3892C178.149 39.0677 177.898 39.7236 177.941 40.4733C178.823 41.1445 180.074 41.7162 181.819 42.3218C181.646 41.1504 181.747 40.5252 182.467 39.9372Z",
    fill: "#A550A7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.756 61.4343C198.562 62.5411 197.775 63.0805 196.265 63.7348C196.574 64.4786 196.968 65.0597 197.607 65.4537C198.663 65.1134 199.847 64.4144 201.341 63.3293C200.282 62.801 199.827 62.3605 199.756 61.4343Z",
    fill: "#007AFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.842 87.6168C214.6 86.4637 213.942 85.9144 212.924 85.1202C211.697 85.3589 210.743 85.4071 209.759 85.75C209.692 87.0896 209.35 87.9671 208.172 89.1762C210.92 89.067 212.43 88.6143 214.842 87.6168Z",
    fill: "#FFC700"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.17 64.586C218.991 63.4639 218.403 62.7119 217.656 61.2461C216.933 61.6006 216.378 62.0306 216.024 62.6933C216.43 63.7254 217.202 64.8634 218.378 66.2872C218.839 65.1966 219.25 64.7149 220.17 64.586Z",
    fill: "#FFC700"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.133 57.9017C201.069 56.5699 201.726 55.878 203.066 54.9227C202.609 54.2597 202.102 53.7738 201.394 53.5221C200.433 54.0754 199.421 55.0064 198.186 56.3798C199.333 56.675 199.87 57.0108 200.133 57.9017Z",
    fill: "#F74F9E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.432 28.4702C227.314 28.0989 226.508 28.3916 225.309 28.8718C224.898 30.0525 224.46 30.9011 224.261 31.924C225.385 32.6559 225.971 33.3931 226.424 35.0192C227.712 32.5894 228.08 31.0566 228.432 28.4702Z",
    fill: "#61BA47"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.935 81.3915C174.019 81.8535 174.846 81.628 176.08 81.248C176.587 80.1052 177.093 79.2955 177.375 78.2924C176.315 77.4706 175.792 76.6876 175.475 75.0298C173.991 77.3455 173.498 78.8428 172.935 81.3915Z",
    fill: "#F74F9E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.659 55.2874C232.065 55.6169 231.112 55.6711 229.481 55.4498C229.36 56.246 229.397 56.9473 229.74 57.6152C230.82 57.8702 232.195 57.8847 234.035 57.7295C233.402 56.7292 233.24 56.1167 233.659 55.2874Z",
    fill: "#F74F9E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.961 72.9995C271.641 74.4788 271.908 75.3951 272.058 77.0336C272.861 76.9723 273.536 76.7788 274.11 76.2943C274.116 75.1853 273.821 73.8423 273.256 72.0838C272.424 72.9258 271.863 73.2208 270.961 72.9995Z",
    fill: "#F74F9E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.148 73.9898C236.448 75.1291 237.133 75.6443 238.19 76.3857C239.404 76.0851 240.354 75.9885 241.319 75.5961C241.318 74.2548 241.615 73.3611 242.73 72.0937C239.991 72.3423 238.506 72.8711 236.148 73.9898Z",
    fill: "#FF5257"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8415_3186",
    x: 16.8542,
    y: -33.3068,
    width: 179.4,
    height: 224.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -60.9365
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.90174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8415_3186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8415_3186",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8415_3186",
    x1: 89.1078,
    y1: 50.4457,
    x2: 123.941,
    y2: 173.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193044,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980696,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8415_3186",
    x1: 92.6101,
    y1: 62.8215,
    x2: 118.143,
    y2: 153.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0212642,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978736,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8415_3186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.85,
    height: 163.948,
    fill: "white",
    transform: "translate(0 36.4444) rotate(-9.81565)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfinandinhoCheck);
export default __webpack_public_path__ + "static/media/afinandinho_check.da7393c1a5331a35906d772b4ed7cb51.svg";
export { ForwardRef as ReactComponent };